import { render, staticRenderFns } from "./MonthlyRevenueChart.vue?vue&type=template&id=ba3ebb32"
import script from "./MonthlyRevenueChart.vue?vue&type=script&lang=js"
export * from "./MonthlyRevenueChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports